var klaviyo = klaviyo || [];

klaviyo.init({
	account: "UhxDSj",
	platform: "shopify",
});
klaviyo.enable("backinstock", {
	trigger: {
		product_page_text: "Wieder-Da-Benachrichtigung einrichten",
		product_page_class: "button button--primary",
		product_page_text_align: "center",
		product_page_margin: "0",
		alternate_anchor: "klaviyo-sold-out",
		replace_anchor: true,
	},
	modal: {
		headline: "{product_name}",
		body_content: "Tragen Sie hier Ihre E-Mail-Adresse ein und Sie werden benachrichtigt, sobald der Artikel verfügbar ist.",
		email_field_label: "E-Mail",
		button_label: "Benachrichtigt werden",
		subscription_success_label: "Das hat funktioniert. Sie erhalten eine E-Mail, sobald das Produkt wieder verfügbar ist.",
		footer_content: "",
		additional_styles: "@import url('https://fonts.googleapis.com/css?family=Helvetica+Neue');",
		drop_background_color: "#000",
		background_color: "#fff",
		text_color: "#222",
		button_text_color: "#fff",
		button_background_color: "#164630",
		close_button_color: "#ccc",
		error_background_color: "#fcd6d7",
		error_text_color: "#C72E2F",
		success_background_color: "#d3efcd",
		success_text_color: "#1B9500",
	},
});
